/**
 * Show the ovelerlay
 *
 * @param {string} overlayClass - The unique class to give to the overlay
 * @param {string} zindex - Level at which to show the overlay
 *
 */
function showOverlay( overlayClass, zindex ) {

	// Create the DOM node
	let biroOverlay = document.createElement( 'div' );

	// Set the classes
	biroOverlay.setAttribute(
		'class',
		'overlay ' + overlayClass
	);

	// Set the z-index
	biroOverlay.style.zIndex = zindex;

	// Display the overlay
	document.body.appendChild( biroOverlay );
}

/**
 * Hide the overlay
 *
 * @param {string} overlayClass - The unique class over the overlay to hide
 *
 */
function hideOverlay( overlayClass ) {
	// Get the DOM node
	let biroOverlay = document.querySelector( '.' + overlayClass );

	// Remove the overlay
	document.body.removeChild( biroOverlay );
}
